export enum ActivityType {
  EventNotificationCreated = 7,
  EventNotificationAoDetailsUpdated = 8,
  EventNotificationOfqualDetailsUpdated = 9,
  EventNotificationClosed = 10,
  EventNotificationReopened = 11,
  EventNotificationAssigned = 12,
  EventNotificationMessageOfqual = 13,
  EventNotificationMessageAo = 14,
  EventNotificationDocumentOfqual = 15,
  EventNotificationDocumentAo = 16,
  ShareRecord = 17,
  UnSharedRecord = 86,
}


export const allActivityTypes = [
  ActivityType.EventNotificationCreated,
  ActivityType.EventNotificationAoDetailsUpdated,
  ActivityType.EventNotificationOfqualDetailsUpdated,
  ActivityType.EventNotificationClosed,
  ActivityType.EventNotificationReopened,
  ActivityType.EventNotificationAssigned,
  ActivityType.EventNotificationMessageOfqual,
  ActivityType.EventNotificationMessageAo,
  ActivityType.EventNotificationDocumentOfqual,
  ActivityType.EventNotificationDocumentAo,
  ActivityType.ShareRecord,
  ActivityType.UnSharedRecord,
]